"use client";
import React from "react";
import { CartProvider } from "@/contexts/CartContext";
import { LikedProvider } from "@/contexts/LikedContext";
import { UserProvider } from "@/contexts/UserContext";
import { PopupProvider } from "@/contexts/PopupContext";
import { SnackbarProvider } from "@/contexts/SnackbarContext";
const Providers = (props: {
    children: React.ReactNode, loggedIn: boolean, ismychaivio?: boolean, mail: string
}) => {
    return (
        <UserProvider loggedIn={props.loggedIn} ismychaivio mail={props.mail}>
            <PopupProvider>
                <SnackbarProvider>
                    <CartProvider>
                        <LikedProvider>{props.children}</LikedProvider>
                    </CartProvider>
                </SnackbarProvider>
            </PopupProvider>
        </UserProvider>
    );
};

export default Providers;
